<ng-container *cdkPortal>
  @if (showBubble()) {
    @if (useChatStartInput()) {
      @if (!isWindowOpen()) {
        <div
          class="chat-start-window z-fx-col z-fx-w100 z-fx-center-center z-fx-gap-16"
          [class.stick-to-bottom]="stickToBottom()"
          (click)="chatInput.focus()"
          (elementResize)="checkOverflow()"
          #startWindow
        >
          <div class="chat-start-container">
            <div class="background z-fx-col">
              <mat-form-field class="chat-start-input z-fx-auto z-fx-w100 zef-textarea-small zef-input-ghost">
                <div matPrefix class="z-fx-col z-fx-start-center z-fx-none">
                  <mat-icon color="ai-gradient">chat</mat-icon>

                  @if (eaw.fileUploadEnabled()) {
                    <input
                      type="file"
                      hidden
                      #startFileInput
                      [accept]="eaw.supportedFileTypes()"
                      (change)="onFileInputChange(startFileInput)"
                    />
                    <button
                      matSuffix
                      mat-icon-button
                      matTooltip="Add context"
                      i18n-matTooltip
                      (click)="$event.stopPropagation(); startFileInput.click()"
                    >
                      <mat-icon class="zef-icon-small">plus</mat-icon>
                    </button>
                  }
                </div>

                <textarea
                  matInput
                  autoSize
                  [(ngModel)]="startQuestion"
                  (keydown.enter)="onKeydownEnter($event)"
                  placeholder="Ask anything..."
                  i18n-placeholder
                  #chatInput="matInput"
                ></textarea>

                <div matSuffix class="a-fx-sc a-fx-gap-4">
                  @if (hasRecentChatActive()) {
                    <button mat-icon-button matTooltip="Open recent chat" i18n-matTooltip (click)="toggleChat()">
                      <mat-icon color="stealth">template</mat-icon>
                    </button>
                  } @else {
                    <button mat-icon-button matTooltip="Open chat" i18n-matTooltip (click)="toggleChat()">
                      <mat-icon color="stealth">template</mat-icon>
                    </button>
                  }

                  @if (!stickToBottom() && scrollContainerHasScroll()) {
                    <button mat-icon-button matTooltip="Set to bottom" i18n-matTooltip (click)="setStickToBottom(true)">
                      <mat-icon color="stealth">close</mat-icon>
                    </button>
                  }
                </div>
              </mat-form-field>
              @if (eaw.attachedFile(); as attachedFile) {
                <div class="z-fx z-fx-none chat-start-file">
                  <div class="zef-chip-small zef-bgcolor-ink chip" [class.zef-bgcolor-alert]="attachedFile.error">
                    <mat-icon class="zef-icon-small">editor_question_upload</mat-icon>
                    {{ attachedFile.fileName }}
                    @if (attachedFile.error) {
                      {{ attachedFile.error }}
                    }
                    <mat-icon (click)="onClearFile()" class="zef-icon-small zef-cursor-pointer">close</mat-icon>
                  </div>
                </div>
              }
              @if (chatStarters().length) {
                <div class="chat-start-suggestions z-fx marquee" #suggestionButtons>
                  <div class="z-fx marquee-content" #marqueeContent>
                    @for (starter of chatStarters(); track starter.prompt) {
                      <button
                        mat-raised-button
                        color="ink"
                        class="chat-start-suggestion z-fx-none zef-ghost-button button"
                        (click)="$event.stopPropagation(); startChat(starter.prompt)"
                      >
                        <span>{{ starter.title }}</span>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    } @else {
      <button
        #chatButton
        class="chat-button zef-gradient-ai"
        mat-icon-button
        cdkDrag
        cdkDragBoundary="body"
        [class.opened]="isWindowOpen()"
        [class.dragging]="dragging()"
        (cdkDragStarted)="dragging.set(true)"
        (cdkDragEnded)="onDragEnded()"
        (click)="toggleChat()"
      >
        <span class="chat-button-inner zef-bgcolor-secondary z-fx-none z-fx-sc">
          <mat-icon class="z-fx-none" color="ink">chat</mat-icon>

          <span class="chat-button-label zef-text-overflow-line z-fx-none" i18n>Ask AI</span>
        </span>
      </button>
    }
  }
</ng-container>
